/**
 * @desc 导入商品尺寸分段信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/ProductSizeSection/importExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
